<template>
    <div class="">
        <!-- Grey logo section -->
        <logo-component v-if="!showPromotionalBanner"></logo-component>

        <!-- Welcome banner -->
        <component :is="welcomeBannerComponent" :offer="featuredOffers[0]"></component>


        <!-- Featured offers slider -->
        <!--<featured-offers-slider-component></featured-offers-slider-component>-->
        <landing-page-featured-offers-slider-component :featuredOffers="featuredOffers"> </landing-page-featured-offers-slider-component>


        <!-- Promo link -->
        <promo-links-component></promo-links-component>

        <!-- Promotional offers -->
        <promotional-offers-component></promotional-offers-component>

        <!-- Footer -->
        <footer-component>
            <template v-slot:after-links v-if="showPromotionalBanner">
                <pre-login-disclosure />
            </template>
        </footer-component>
    </div>
</template>

<script>
    import HeaderComponent from "./HeaderComponent.vue";
    import SpacerComponent from "./SpacerComponent";
    import FeaturedOfferComponent from "./FeaturedOfferComponent";
    import FooterComponent from './FooterComponent.vue';
    import PromoLinksComponent from './PromoLinksComponent.vue';
    import PromotionalOffersComponent from './PromotionalOffersComponent.vue';
    import LogoComponent from './LogoComponent.vue';
    import WelcomeBannerPromotionComponent from './banners/WelcomeBannerPromotionComponent.vue';
    import WelcomeBannerComponent from './banners/WelcomeBannerComponent.vue';
    import LandingPageFeaturedOffersSliderComponent from "./LandingPageFeaturedOffersSlider";
    import PreLoginDisclosure from "./promotions/PreLoginDisclosure.vue";

    export default {
        name: "LandingPageComponent",
        components: {
            LandingPageFeaturedOffersSliderComponent,
            HeaderComponent,
            FeaturedOfferComponent,
            SpacerComponent,
            FooterComponent,
            PromoLinksComponent,
            PromotionalOffersComponent,
            LogoComponent,
            WelcomeBannerComponent,
            WelcomeBannerPromotionComponent,
            PreLoginDisclosure
        },
        data () {
            return {
                featuredOffers : [],
                showPromotionalBanner: window.appGlobalData.showPromotionalBanner,
                welcomeBannerComponent : window.appGlobalData.showPromotionalBanner?WelcomeBannerPromotionComponent:WelcomeBannerComponent
            }
        },

        methods:  {
            getPreLoginFeaturedOffers() {

                axios.get(this.apiEndPoints.getPreLoginFeaturedOffers, {})
                    .then(response => {
                        if(response.data) {
                            this.featuredOffers = response.data;
                        }
                    }).catch(error => {

                    if (error.response && error.response.status && (error.response.status == 401 || error.response.status == 419)) {

                    }

                    return false;
                });
            }
    },

        mounted() {
            this.getPreLoginFeaturedOffers();
        }

    }
</script>

<style scoped>

    .gradient-black {
        background-color: black;
        background-image:
            linear-gradient(
                to right,
                black, #808B96
            );
    }

    #first-block {
        /*height: 400px;*/
        padding: 20px 40px 20px 40px;
    }

    #welcome-message {
        color: white;
        /*font-weight:bold;*/
        font-size: 32px ;

    }

    #logo {
        width:100px;
        height:50px;
        background:white;
    }


    .register {
    }

    .btn-lg:hover {
        /*color: #;*/
        background: grey;
        /*border: 2px solid grey;*/
    }


</style>
